module.exports = "<div class=\"ui-modal\">\n  <div class=\"ui-modal-transcluded\"></div>\n</div>\n";